module.exports = __webpack_public_path__ + "img/Datacleaningselect.2f3b9879.svg";